import React from 'react';

interface PageLoaderProps {
    label?: string;
    detail?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ label = 'Ładowanie...', detail }) => (
    <div className="fc-page-loader" role="status" aria-label={label}>
        <div className="fc-page-loader__content">
            <svg className="fc-page-loader__wheel" viewBox="0 0 100 100" aria-hidden="true">
                <circle className="fc-page-loader__tire" cx="50" cy="50" r="45" />
                <circle className="fc-page-loader__rim" cx="50" cy="50" r="34" />
                <circle className="fc-page-loader__barrel" cx="50" cy="50" r="27" />
                <g>
                    {[0, 72, 144, 216, 288].map((angle) => (
                        <g key={angle} transform={`rotate(${angle} 50 50)`}>
                            <path className="fc-page-loader__spoke" d="M46 48 L40 20 L48 17 L53 47 Z" />
                            <path className="fc-page-loader__spoke-edge" d="M47 44 L43 23" />
                        </g>
                    ))}
                </g>
                <circle className="fc-page-loader__hub" cx="50" cy="50" r="11" />
                <circle className="fc-page-loader__hub-cap" cx="50" cy="50" r="5" />
                <circle className="fc-page-loader__valve" cx="69" cy="69" r="3" />
            </svg>
            <p className="fc-page-loader__label">{label}</p>
            {detail && <p className="fc-page-loader__detail">{detail}</p>}
        </div>
    </div>
);

export default PageLoader;